import React, { useEffect, useState } from 'react';
import styled from 'styled-components';

const FoodSec = styled.div`
  position: absolute;
  bottom: 5px;
  left: 50%;
  transform: translateX(-50%);
  pointer-events: none;
  user-select: none;
`;

type Props = {
  data?: string[];
};
function Food({ data }: Props) {
  if (!data) return null;

  const [img, setImg] = useState('');

  useEffect(() => {
    const selectRandomString = () => {
      const randomIndex = Math.floor(Math.random() * data.length);
      setImg(data[randomIndex]);
    };

    selectRandomString();
  }, [data]);

  return (
    <FoodSec className="food">
      <img src={img} alt="" />
    </FoodSec>
  );
}

export default Food;
